//import BtnBehaviourConfig from '@/common/js/btnBehaviourConfig';
import textConfig from '@/common/js/textConfig';

const ua = navigator.userAgent.toLocaleLowerCase();
const ENVQuery = () => {
    if (ua.includes("alipayclient")) return "alipay";

    // 微信小程序环境
    if (ua.includes('micromessenger') && window.__wxjs_environment === 'miniprogram') return "miniprogram";

    // 微信公众号环境
    if (ua.includes('micromessenger')) return "wechat";
    return 'pc';
};

export default {
    pageNAME: '',

    TC: textConfig,         //配置页面文案

    title: textConfig.pay.index.bankName,
    hideLoading: true,      // 默认隐藏loading条 {f5,强刷新时}Loading store未注册

    // 基础
    h: 0, //document.documentElement.clientHeight,
    w: 0, //document.documentElement.clientWidth,
    IS_ANDROID: ua.indexOf('android') !== -1,
    IS_IOS: ua.indexOf('iphone') !== -1,
    IS_NATIVE: Boolean(this.IS_ANDROID || this.IS_IOS),
    ENV: ENVQuery(),

    // 用户信息集合
    userInfo: {

        // 用户状态
        userStatus: '',

        // 还款状态
        repay_status: '',

        // 操作步骤, 中断信息标识
        step: {},

        // 首页三种状态
        homeState: '',

        canLoanAmount: 0,      // 可申请额度
        totalLoanAmount: 0,    // 总额度
        apply_allow: 0,        // 进件许可

        individual: {},             // 个人信息[姓名name, 身份证identity, 手机号mobile]
        bank_info: {},
        identity_ocr_status: null,   // 是否做过身份证ocr
        user_info_status: null,      // 是否需要补充信息 {complete 不需要, incomplete 需要}
        error_toast: '',             // 弹窗信息

        // 开户时间限制
        biz_stop_open_card2: {
            start: '',
            end: ''
        },

        // 注册提示信息
        first_register: {
            status: false,
            msg: ''
        },

        loan_rate: '',  // 日利率

        //联系人列表
        "contact_list": [
            {
                "individual_contact_type": 4,
                "individual_contact_name": "郭靖", //姓名
                "individual_contact_phone": "18021908366" //电话
            },
            {
                "individual_contact_type": 0,
                "individual_contact_name": "黄蓉",
                "individual_contact_phone": "15751776166"
            }
        ],

        // 系统维护时间
        service_stop_tips: 0        // 默认为0，非维护状态
    },

    // 企业类型数据
    companyTypeSelect: [],

    // 联系人类型 0, 1, 2, 3, 4
    contactTypeSelect: ['配偶', '父母', '兄弟', '姐妹', '朋友'],

    // 首页关联的状态 =>
    homeRelation: {
        not_register: 1,    // 未注册
        no_quali: 1,        // 不在白名单
        froze: 1,           // 冻结用户
        result_waiting: 1,  // 等待出结果
        faceid_verify: 1,   // 需要人脸认证

        none: 2,            // 无贷款记录
        grant_waiting: 2,   // 等待放款(不能发起借款)

        re_verify: 5,       // 额度已过期
    },

    // 全局流程状态映射路由
    // processRoute: {
    //     loan: {
    //         uncommit: 'loan',
    //         commit: 'loanPolling',
    //         apply_result: 'loan',
    //         refuse: 'loan'
    //     },

    //     // 贷款已结束的状态
    //     inLoanComputedState: {
    //         repay: true,
    //         refuse: true,
    //         grant_fail: true
    //     },
    // },

    // 联系人关系
    // contactRelation: {
    //     '配偶': 0,
    //     '父母': 1,
    //     '兄弟': 2,
    //     '姐妹': 3,
    //     '朋友': 4
    // },

    // 失去焦点的tagName
    blurType: ['INPUT', 'TEXTAREA', 'SELECT'],

    // 验证码倒计时
    unchangedDownTime: 60,
    downTime: 60,

    // 当前路由
    currentRoutePath: '',

    // 接口状态码
    apiStateKey: {
        "101003" : ['__reloadLogin', '请登录'],
        "101012" : ['__reloadLogin', '登录超时，点击跳回登录页面！'],
        '101018' : ['__reloadLogin', '点击跳至微信授权'],
        '101017' : ['__toWhilePage', '白名单code单独处理'],
        '220004' : ['__reloadUnionLogin', '请登录'],
        // 'xxxxxx' : ['__updating', '系统升级中']
        //'100000' : ['__perfectInformation', '点击跳至补充信息'],
    },

    // 需要人脸认证的code
    apiFaceidKey: [102050],

    // 轮播图
    // ad: {
    //     home: []
    // },

    // 第三方资源加载状态
    third: {
        networkType: null,
        wxjs: false,
        wxSign: false
    },

    // http取消队列
    xmlHttpCancelQueue: [],

    // lpr用户信息集合
    lprUserInfo: {
        // 用户状态
        userStatus: '',

        face_status: '',
        first_register_toast: '',

        identity_ocr_status: null,   // 是否做过身份证ocr
        check_individual_validity: '',  //invalid-无效；身份证过期需要重新ocr
        error_toast: '',             // 弹窗信息


        // 注册提示信息
        first_register: {
            status: false,
            msg: ''
        },

        // 系统维护时间
        service_stop_tips: null
    },
    productList: [],
    
    //申请是否已经提交
    isSubmitting: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js